export class SSREmojiTitleManager {
	private emojiTitleData: any = null;

	setEmojiTitleData(data: any) {
		this.emojiTitleData = data;
	}

	getEmojiTitleData() {
		return this.emojiTitleData;
	}
}
